
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPumpOffVertical as ObiPumpOffVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pump-off-vertical.js';
 
 
 

 
 export const ObiPumpOffVertical = createComponent({
   react: React,
   tagName: 'obi-pump-off-vertical',
   elementClass: ObiPumpOffVerticalElement,
   events: {
     
   }
  });
 
 